import { IconAlertCircle } from '@tabler/icons-react'
import styled from 'styled-components'

import { helpers } from '../../../../styles/theme'

export const Icon = styled(IconAlertCircle)`
	color: ${helpers.color.input.errorBoxIcon};
`
